import { FC, SVGProps } from 'react';

export const UsersOutlined: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M7.6752 11.1725C10.1966 11.1725 12.3516 11.5546 12.3516 13.0808C12.3516 14.607 10.2109 15 7.6752 15C5.15313 15 2.99878 14.6214 2.99878 13.0945C2.99878 11.5675 5.13878 11.1725 7.6752 11.1725Z"
			stroke="currentColor"
			strokeWidth="1.2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M7.67527 8.99419C6.01986 8.99419 4.67749 7.6525 4.67749 5.99709C4.67749 4.34169 6.01986 3 7.67527 3C9.32999 3 10.6724 4.34169 10.6724 5.99709C10.6785 7.64635 9.34571 8.98804 7.69646 8.99419H7.67527Z"
			stroke="currentColor"
			strokeWidth="1.2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M12.3855 8.21621C13.4798 8.06242 14.3225 7.12331 14.3246 5.98667C14.3246 4.86643 13.5078 3.93689 12.4368 3.76123"
			stroke="currentColor"
			strokeWidth="1.2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M13.8293 10.8481C14.8894 11.006 15.6297 11.3778 15.6297 12.1433C15.6297 12.6703 15.2811 13.012 14.7179 13.2259"
			stroke="currentColor"
			strokeWidth="1.2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);
